import { Grid, Typography } from "@material-ui/core";
import BankViewDto from "../../../../../../consumer/bank/dto/BankViewDto";

const Bankinstitut: React.FC<{ bank?: BankViewDto, loading: boolean }> = ({ loading, bank }) => {
    return (
        <Grid container>
            <Grid item xs={12} md={3}><Typography color='textPrimary' style={{ fontWeight: 'bold' }}>Bankinstitut:</Typography></Grid>
            <Grid item xs={12} md={9}><Typography color='textPrimary'>{bank?.name}</Typography></Grid>
            <Grid item xs={12} md={3}><Typography color='textPrimary' style={{ fontWeight: 'bold' }}>BIC:</Typography></Grid>
            <Grid item xs={12} md={9}><Typography color='textPrimary'>{bank?.bic}</Typography></Grid>
        </Grid>
    );
}

export default Bankinstitut;